import React, { Component } from "react";
import Button from "../../../button-classic/button-classic";
import "../../../route_code/route_code.less";
import InputText from "../../../../common/components/input-text/input-text";
import Select from "react-select";
import Cx from "classnames";
import ACTIONS from "../../../../common/action_constant";

class AddFocusMaster extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: {
        plant_code: props.editData?.plant_code || "",
        plant_label: props.editData?.plant_code || "",
        region: props.editData?.region_code || "",
        region_label: props.editData?.region_name || "",
        county_description:
          props.editData?.county_description || "",
        county_description: props.editData?.county_description || "",
        county_code:
          props.editData?.county_code || "",
        company_id: props.companyId || "",
      },
    };
  }

  componentDidUpdate(prevProps) {

    if (prevProps.companyId !== this.props.companyId) {
      this.setState((prevState) => ({
        data: {
          ...prevState.data,
          company_id: this.props.companyId,
        },
      }));
    }


    if (prevProps.editData !== this.props.editData && this.props.editData) {
      this.setState({
        data: {
          plant_code: this.props.editData.plant_code || "",
          plant_label: this.props.editData.plant_code || "",
          region: this.props.editData.region_code || "",
          region_label: this.props.editData.region_name || "",
          county_description:
            this.props.editData.county_description || "",
          county_description: this.props.editData.county_description || "",
          county_code:
            this.props.editData.county_code || "",
          company_id: this.props.companyId,
        },
      });
    }
  }

  onChangeHandler = (value, field) => {
    this.setState((prevState) => ({
      data: {
        ...prevState.data,
        [field]: value,
      },
    }));
  };

onSave = () => {
  const { data } = this.state;
  const {
    dispatch,
    editData,
    toggleAdd,
    refreshData,
    regionOptions,
    match,
    companyId
  } = this.props;

  const resolvedCompanyId = companyId || match?.params?.id || data?.company_id;

  if (!resolvedCompanyId) {
    return;
  }

  const selectedRegion = regionOptions.find(
    (opt) => opt.value === data.region
  );

  const payload = {
    plant_code: data.plant_code,
    company_id: resolvedCompanyId,
    region_code: data.region,
    region_name: selectedRegion?.label || "",
    county_code: data.county_code,
    county_description: data.county_description,
    ...(editData && { focus_plant_id: editData.focus_plant_id })
  };

  dispatch({
    type: editData
      ? ACTIONS.PLANTS.UPDATE_FOCUS_PLANTS_MASTER
      : ACTIONS.PLANTS.ADD_FOCUS_PLANTS_MASTER,
    data: payload,
    onSuccess: () => {
      toggleAdd();
      refreshData?.();
    }
  });
};



  render() {
    const { data } = this.state;
    const {
      plantOptions = [],
      regionOptions = [],
      countyOptions = [],
      toggleAdd,
      editData,
    } = this.props;

    return (
      <div className="route_code_detail">
        <div className="overlay" onClick={toggleAdd} />

        <div className="modal-popup" style={{ minWidth: "600px" }}>
          <div className="pop-heading">
            {editData ? "Edit" : "Add"} Focus Configuration
          </div>

          <div className="route-detail" style={{ padding: "30px" }}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "20px",
              }}
            >
              <div>
                <div className="label">
                  Plant Code <span className="error-color">*</span>
                </div>
                <Select
                  className={Cx("selectpack")}
                  options={plantOptions}
                  value={{
                    value: data.plant_code,
                    label: data.plant_label
                  }}
                  onChange={(e) =>
                    this.setState(prev => ({
                      data: {
                        ...prev.data,
                        plant_code: e.value,
                        plant_label: e.label
                      }
                    }))
                  }
                />
              </div>

              <div>
                <div className="label">
                  Region <span className="error-color">*</span>
                </div>
                <Select
                  className={Cx("selectpack")}
                  options={regionOptions}
                  value={{
                    value: data.region,
                    label: data.region_label
                  }}
                  onChange={(e) =>
                    this.setState(prev => ({
                      data: {
                        ...prev.data,
                        region: e.value,
                        region_label: e.label
                      }
                    }))
                  }
                />
              </div>

              <div>
                <div className="label">
                  County Description <span className="error-color">*</span>
                </div>
                <Select
                  className={Cx("selectpack")}
                  options={countyOptions}
                  value={{
                    value: data.county_code,
                    label: data.county_description
                  }}
                  onChange={(e) =>
                    this.setState(prev => ({
                      data: {
                        ...prev.data,
                        county_code: e.value,
                        county_description: e.label
                      }
                    }))
                  }
                />
              </div>


              <div>
                <InputText
                  label="County Code"
                  value={data.county_code}
                  disabled
                  placeholder="Auto-populated"
                />
              </div>
            </div>

            <div className="button_route" style={{ marginTop: "50px" }}>
              <Button value="Cancel" click={toggleAdd} />
              <Button
                value={editData ? "Update" : "Save"}
                disabled={!data.plant_code || !data.county_description}
                click={this.onSave}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddFocusMaster;
